import { getEvents } from '@/services/webApi';
import {
  EventsQueryInput,
  EventsResponse
} from '@goodneighbor/api/schemas/events/index';
import { useInfiniteQuery } from '@tanstack/react-query';

export default function useInfiniteEventsQuery(
  query: Omit<EventsQueryInput, 'page'>
) {
  return useInfiniteQuery({
    queryKey: ['events', 'infinite', query],
    queryFn: async ({ pageParam }) => getEvents({ ...query, page: pageParam }),
    initialPageParam: '1',
    getNextPageParam: (lastPage: EventsResponse) => {
      const next = lastPage?.data?.meta?.pagination?.nextPage;
      return next != null ? String(next) : undefined;
    },
    retry: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });
}
